import { motion } from 'framer-motion';

export default function Services() {
  return (
    <section className="bg-white py-16 sm:py-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-12 sm:mb-16 gap-6 sm:gap-8">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-inter font-bold text-3xl sm:text-4xl lg:text-5xl text-gray-900 lg:w-2/5"
          >
            Serviços de Arquitetura
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-inter text-sm sm:text-base text-gray-600 leading-relaxed lg:w-1/2"
          >
            O Criarquitetura atua com abordagem personalizada, desenvolvendo projetos completos desde o conceito até a execução. Cada etapa é planejada para garantir qualidade técnica e resultado estético alinhado às expectativas do cliente.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-gray-50 rounded-3xl p-6 sm:p-10 hover:shadow-xl transition-shadow duration-300"
          >
            <div className="aspect-video rounded-2xl overflow-hidden mb-6 sm:mb-8">
              <img
                src="https://public.readdy.ai/ai/img_res/24d5dde8a143daf204016f091904057c.jpg"
                alt="Projetos residenciais completos em Ilhabela - Do conceito ao executivo"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="font-inter font-semibold text-xl sm:text-2xl text-gray-900 mb-3 sm:mb-4">
              Projetos Residenciais Completos
            </h3>
            <p className="font-inter text-sm text-gray-700 leading-relaxed mb-4 sm:mb-6">
              Desenvolvemos projetos arquitetônicos completos para residências em Ilhabela, desde o estudo preliminar até o projeto executivo. Cada etapa é cuidadosamente planejada para atender às necessidades do cliente e às características do terreno litorâneo.
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Estudo preliminar e anteprojeto</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Projeto executivo completo</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Compatibilização técnica</span>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-gray-50 rounded-3xl p-6 sm:p-10 hover:shadow-xl transition-shadow duration-300"
          >
            <h3 className="font-inter font-semibold text-lg sm:text-xl text-gray-900 mb-4 sm:mb-6 text-center">
              Arquitetura Litorânea Especializada
            </h3>
            <div className="aspect-square rounded-2xl overflow-hidden mb-6 sm:mb-8">
              <img
                src="https://static.readdy.ai/image/c30d1200a69d27266a785c8d79b381ff/497f0d3911cc4ea71dccd19eea13750f.png"
                alt="Arquitetura litorânea - Materiais e soluções para casas de praia"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Ventilação natural otimizada</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Materiais resistentes à maresia</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Integração interior-exterior</span>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-gray-50 rounded-3xl p-6 sm:p-10 hover:shadow-xl transition-shadow duration-300 sm:col-span-2 lg:col-span-1"
          >
            <h3 className="font-inter font-semibold text-lg sm:text-xl text-gray-900 mb-4 sm:mb-6 text-center">
              Acompanhamento de Obra
            </h3>
            <div className="aspect-square rounded-2xl overflow-hidden mb-6 sm:mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=construction%20site%20of%20modern%20house%20being%20built%2C%20architectural%20supervision%2C%20building%20in%20progress%20with%20concrete%20structure%2C%20professional%20construction%20management%2C%20clean%20organized%20worksite%2C%20simple%20background&width=600&height=600&seq=service-003&orientation=squarish"
                alt="Acompanhamento de obra - Gestão técnica de projetos em Ilhabela"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Visitas técnicas periódicas</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Controle de qualidade</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-accent text-lg mt-0.5"></i>
                <span className="font-inter text-sm text-gray-700">Fidelidade ao projeto</span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
